import { render, staticRenderFns } from "./BulkClearInflightModal.vue?vue&type=template&id=24ed04fa&"
import script from "./BulkClearInflightModal.vue?vue&type=script&lang=js&"
export * from "./BulkClearInflightModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports